import {create} from 'zustand'
import {devtools} from 'zustand/middleware'

import { deleteUserAccessSections, deleteUserAccessSites, deleteUserCard, getUserCard, getUsers, postUserAccessSections, postUserAccessSites, postUserCard, putUserAccessSectionsChecked, putUserCard } from './api'

import { IUsersActions, UsersListType, IUsersState, CardUserSendFormType } from './state.types'
import { createLatestRequestController } from '../latest-request'


export const initialStateUsers: IUsersState = {
    isLoadingCard: false,
    isLoadingCheckedSectionRead: false,
    isLoadingCheckedSectionEdit: false,
    isLoadingCheckedSectionDelete: false,

 
    users: {
        isLoading: false,

        items: [] as UsersListType[],
        totalCount: 0,
        pageSize: 0,
        currentPage: 0,
        canRead: false,
        canEdit: false,
        canDelete: false
    },

    userCard: {
        loginName: '',
        lastName: '',
        firstName: '',
        secondName: '',
        accessLevelID: 0,
        accessLevelName: '',
        isLocked: 0,
        canEdit: false,
        canDelete: false,
    },

}

const usersListRequest = createLatestRequestController()
const userCardRequest = createLatestRequestController()

/** Хранилище страницы - Операторы */
export const useUsers = create<IUsersState & IUsersActions>()(devtools((set) => ({
    ...initialStateUsers,

    /** Сброс хранилища, до начального состояния */
    clearStateUsers: () => {
        usersListRequest.invalidate()
        userCardRequest.invalidate()
        set(initialStateUsers)
    },

    /** Сброс анкеты оператора, до начального состояния */
    clearStateUserCard: () => {
        userCardRequest.invalidate()
        set(() => ({
            userCard: {
                loginName: '',
                lastName: '',
                firstName: '',
                secondName: '',
                accessLevelID: 0,
                accessLevelName: '',
                isLocked: 0,
                canEdit: false,
                canDelete: false,
            }
        }))
    },
    


    /** Получение списка операторов */
    actionGetUsers: async (pageNumber: number, search: string, isShowLoading: boolean = true) => {
        const request = usersListRequest.start()
        set((state) => ({ 
            users: { 
                ...state.users, 
                isLoading: isShowLoading 
            } 
        }))


        /** Выполняем запрос */
        const response = await getUsers(pageNumber, search, !isShowLoading, request.signal)
        if (!request.isCurrent()) return response
        request.finish()

        // Проверка статуса
        if (response.status === 200) {
            set((state) => ({
                users: {
                    ...state.users,
                    items: response.data!.items,
                    totalCount: response.data!.totalCount,
                    pageSize: response.data!.pageSize,
                    currentPage: response.data!.currentPage,
                    canRead: true,
                    canEdit: response.data!.canEdit === true,
                    canDelete: response.data!.canDelete === true
                }
            }))
        }

        if (response.status === 401 || response.status === 403) {
            set((state) => ({users: {...state.users, canRead: false, canEdit: false, canDelete: false}}))
        }

        set((state) => ({ 
            users: { 
                ...state.users, 
                isLoading: false 
            } 
        }))

        return response
    },

    /** Получение данных по анкете оператора */
    actionGetUserCard: async (loginID: number) => {
        const request = userCardRequest.start()
        set(state => ({isLoadingCard: true, userCard: {...state.userCard, canEdit: false, canDelete: false}}))

        /** Выполняем запрос */
        const response = await getUserCard(loginID, request.signal)
        if (!request.isCurrent()) return response
        request.finish()

        // Проверка статуса
        if (response.status === 200) {
            set((state) => ({
                userCard: {
                    ...state.userCard,
                    
                    loginName: response.data!.loginName,
                    lastName: response.data!.lastName,
                    firstName: response.data!.firstName,
                    secondName: response.data!.secondName,
                    accessLevelID: response.data!.accessLevelID,
                    accessLevelName: response.data!.accessLevelName,
                    isLocked: response.data!.isLocked,
                    canEdit: response.data!.canEdit === true,
                    canDelete: response.data!.canDelete === true,
                }
            }))
        }

        set({isLoadingCard: false})

        return response
    },

    /** Создание нового оператора */
    actionPostUserCard: async (data: CardUserSendFormType) => {
        set({isLoadingCard: true})

        try {
            return await postUserCard(data)
        } finally {
            set({isLoadingCard: false})
        }
    },

    /** Обновление данных по оператору */
    actionPutUserCard: async (loginID: number, data: CardUserSendFormType) => {
        set({isLoadingCard: true})

        try {
            return await putUserCard(loginID, data)
        } finally {
            set({isLoadingCard: false})
        }
    },

    /** Удаление оператора */
    actionDeleteUserCard: async (loginID: number) => {
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const response = await deleteUserCard(loginID)

        // Проверка статуса
        if (response.status === 200) {}

        // set({isLoadingCard: false})

        return response
    },

    /** Создание допуска к сайту для оператора */
    actionPostUserAccessSites: async (loginID: number, siteID: number) => {
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const response = await postUserAccessSites(loginID, siteID)

        // Проверка статуса
        if (response.status === 200) {}

        // set({isLoadingCard: false})

        return response
    },

    /** Создание допуска к разделу для оператора */
    actionPostUserAccessSections: async (loginID: number, accessSectionID: number) => {
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const response = await postUserAccessSections(loginID, accessSectionID)

        // Проверка статуса
        if (response.status === 200) {}

        // set({isLoadingCard: false})

        return response
    },

    /** Удаление допуска к сайту для оператора */
    actionDeleteUserAccessSites: async (loginSiteID: number) => {
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const response = await deleteUserAccessSites(loginSiteID)

        // Проверка статуса
        if (response.status === 200) {}

        // set({isLoadingCard: false})

        return response
    },

    /** Удаление допуска к разделу для оператора */
    actionDeleteUserAccessSections: async (accessID: number) => {
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const response = await deleteUserAccessSections(accessID)

        // Проверка статуса
        if (response.status === 200) {}

        // set({isLoadingCard: false})

        return response
    },

    /** Манипуляции оператора по разделам (чтение, редактирование, удаление) */
    actionPutUserAccessSectionsChecked: async (accessID: number, type: string, isCheked: number) => {
        type === 'read' && set({isLoadingCheckedSectionRead: true})
        type === 'edit' && set({isLoadingCheckedSectionEdit: true})
        type === 'delete' && set({isLoadingCheckedSectionDelete: true})

        /** Выполняем запрос */
        const response = await putUserAccessSectionsChecked(accessID, type, isCheked)

        // Проверка статуса
        if (response.status === 200) {}

        type === 'read' && set({isLoadingCheckedSectionRead: false})
        type === 'edit' && set({isLoadingCheckedSectionEdit: false})
        type === 'delete' && set({isLoadingCheckedSectionDelete: false})

        return response
    },

}), {name: 'StateUsers'}))